module.exports = __webpack_public_path__ + "media/images/icon__locked-0374fe5c903e5cdf458e470e6a5f0dee.png";